import { render, staticRenderFns } from "./preEducation.vue?vue&type=template&id=2c5fccea&scoped=true"
import script from "./preEducation.vue?vue&type=script&lang=js"
export * from "./preEducation.vue?vue&type=script&lang=js"
import style0 from "./preEducation.vue?vue&type=style&index=0&id=2c5fccea&lang=scss&scoped=true"
import style1 from "./preEducation.vue?vue&type=style&index=1&id=2c5fccea&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5fccea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\App_php\\cqjtdx\\cqjtdx_student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c5fccea')) {
      api.createRecord('2c5fccea', component.options)
    } else {
      api.reload('2c5fccea', component.options)
    }
    module.hot.accept("./preEducation.vue?vue&type=template&id=2c5fccea&scoped=true", function () {
      api.rerender('2c5fccea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/concatTeacher/preEducation.vue"
export default component.exports